<template lang="html">
    <div>
        
    </div>
</template>
<script>
export default {
    name:"null"
}
</script>
<style lang="css">
    
</style>